module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./axios/index.js
// module id = 255
// module chunks = 0